import { apiFetch } from "@/lib/api";

export type AirportService = {
  id: number;
  service_code: string;
  airport: string;
  service_name: string;
  description?: string | null;
  service_type: string;
  pricing_type: string;
  price_op: number;
  price_ag: number;
  price_cf: number;
  supplier_name?: string | null;
  cost_supplier?: number | null;
  tax_percentage?: number | null;
  hcte_notes?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type AirportServiceListItem = {
  id: number;
  service_code: string;
  airport: string;
  service_name: string;
  service_type: string;
  supplier_name?: string | null;
};

export type AirportServiceListResponse = {
  items: AirportServiceListItem[];
  total: number;
};

export const fetchAirportServices = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<AirportServiceListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<AirportServiceListResponse | null>(`/airport-services?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getAirportService = async (id: number): Promise<AirportService> => {
  return apiFetch<AirportService>(`/airport-services/${id}`);
};

export const createAirportService = async (data: Partial<AirportService>): Promise<AirportService> => {
  return apiFetch<AirportService>("/airport-services", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateAirportService = async (id: number, data: Partial<AirportService>): Promise<AirportService> => {
  return apiFetch<AirportService>(`/airport-services/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAirportService = async (id: number): Promise<void> => {
  await apiFetch<void>(`/airport-services/${id}`, { method: "DELETE" });
};

export const deleteAllAirportServices = async (): Promise<void> => {
  await apiFetch<void>("/airport-services", { method: "DELETE" });
};
